<div id="modal-container">
  <mat-list id="list-container">
    <div mat-dialog-title class="dialog-title">
      <h3>{{translation.what_is_new_title}} {{version}}</h3>
    </div>
    <button class="close-button" mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <mat-list-item class="mat-list-item-word-wrap" *ngFor="let message of messages"><p mat-line>{{message}}</p></mat-list-item>
  </mat-list>
</div>
